import { HTTP_STATUS } from '@/utils/httpStatusCodes';

interface ErrorResponse {
  status: number;
}

export class UserInfoError extends Error {
  public readonly response: ErrorResponse;

  public readonly isSapUserNotLinked: boolean;

  public readonly isUnauthorized: boolean;

  constructor(response: ErrorResponse) {
    const message =
      response.status === HTTP_STATUS.BAD_REQUEST
        ? 'SAP user not linked'
        : 'Unauthorized';

    super(message);
    this.name = 'UserInfoError';
    this.response = response;
    this.isSapUserNotLinked = response.status === HTTP_STATUS.BAD_REQUEST;
    this.isUnauthorized = response.status === HTTP_STATUS.UNAUTHORIZED;
  }
}
